import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query'
import { inventoryService } from '@/services/InventoryService'
import { inventoryKeys } from '@/hooks/queryKeys'
import type { VenueInventoryDto } from '@lib/dto/venue-inventory.dto'
import type { SetInventoryLineInput } from '@lib/input/venue-inventory.input'

/** A venue's current base inventory. */
export function useVenueInventory(venueId: string): UseQueryResult<VenueInventoryDto> {
  return useQuery({
    queryKey: inventoryKeys.venue(venueId),
    queryFn: () => inventoryService.getForVenue(venueId),
    staleTime: 30_000,
  })
}

/** Set one inventory line in place (movable pool or a space); 0 removes it.
 * Updates the cache with the returned inventory on success. */
export function useSetInventoryLine(venueId: string): UseMutationResult<VenueInventoryDto, Error, SetInventoryLineInput> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: SetInventoryLineInput) => inventoryService.setLine(venueId, input),
    onSuccess: (data) => {
      queryClient.setQueryData(inventoryKeys.venue(venueId), data)
    },
  })
}
